import { useTheme } from '@emotion/react'
import { isFeatureEnabled } from '@etrigan/feature-toggles-client'
import { WithFeatures } from '@etrigan/feature-toggles/dist/middleware'
import { useFeature } from '@news-mono/web-common'
import express from 'express'
import React from 'react'
import { Logger } from 'typescript-log'
import { useProduct } from '../../__product/useProduct'
import { applyContainerRatio } from '../Picture/responsive'
import { PNJabTracker } from './components/perthnow/PNJabTracker'
import { JabTrackerSkeleton } from './components/shared/JabTrackerSkeleton'
import { TWJabTracker } from './components/thewest/TWJabTracker'
import { useJabTrackerData } from './hooks/useJabTrackerData'
import { JabTrackerContainerProps } from './types'

// temp express endpoint handler for - '/test-data/covid-tracker'
// useJabTrackerData() hits this endpoint
export const generateTestJabTrackerDataTW = (): express.Handler => {
    return async (
        req: express.Request & { log: Logger } & WithFeatures,
        res,
    ) => {
        if (!isFeatureEnabled(req.features, 'jab-tracker')) {
            return res.status(404).send()
        }

        req.log.debug({ req }, `test covid data requested`)

        res.set({
            'Content-Type': 'application/json',
        })

        const data = require('./hooks/covid-live-test.json')

        return res.send(data)
    }
}

export const generateTestJabTrackerDataPN = (): express.Handler => {
    return async (
        req: express.Request & { log: Logger } & WithFeatures,
        res,
    ) => {
        if (!isFeatureEnabled(req.features, 'jab-tracker')) {
            return res.status(404).send()
        }

        req.log.debug({ req }, `test covid data requested`)

        res.set({
            'Content-Type': 'application/json',
        })

        const data = require('./hooks/covid-live-test.json')

        return res.send(data)
    }
}

export function JabTracker(props: JabTrackerContainerProps) {
    const { ratios, contentApi } = props
    const theme = useTheme()
    const product = useProduct()
    const isEnabled = useFeature('jab-tracker')

    const { isLoading, isError, data } = useJabTrackerData({ contentApi })
    const containerRatios = applyContainerRatio(ratios, {
        mobile: '100vw',
        tablet: '100vw',
        desktop: `${theme.siteMetrics.mainContentWidth}px`,
        fallbackWidth: theme.siteMetrics.mainContentWidth,
    })

    if (isLoading || isError) {
        if (!isEnabled) {
            return null
        }
        return (
            <>
                <JabTrackerSkeleton
                    type="large"
                    containerRatios={containerRatios}
                />
                <JabTrackerSkeleton
                    type="small"
                    containerRatios={containerRatios}
                />
            </>
        )
    }

    if (product === 'thewest' && isEnabled) {
        return (
            <>
                <TWJabTracker
                    containerRatios={containerRatios}
                    isLoading={isLoading}
                    isError={isError}
                    data={data}
                    type="large"
                />
                <TWJabTracker
                    containerRatios={containerRatios}
                    isLoading={isLoading}
                    isError={isError}
                    data={data}
                    type="small"
                />
            </>
        )
    } else if (product === 'perthnow' && isEnabled) {
        return (
            <>
                <PNJabTracker
                    type="large"
                    containerRatios={containerRatios}
                    isLoading={isLoading}
                    isError={isError}
                    data={data}
                />
                <PNJabTracker
                    type="small"
                    containerRatios={containerRatios}
                    isLoading={isLoading}
                    isError={isError}
                    data={data}
                />
            </>
        )
    }
    return null
}
